module.exports = __webpack_public_path__ + "static/media/elixir-arsign-img-1.3a76ddcd.jpg";